import "./OnlineApplicationsAndVisas.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
export default function OnlineApplicationsAndVisasPage() {
  return <div>
      <Header />
      <Footer />
    </div>;
}